import Cta from "./Cta"
import { ErrorBoundary } from 'components'

function PrimaryCta(_props) {
  const { children, isSubmitting=false, submittingLabel="Enviando", ...rest } = _props
  return (
    <ErrorBoundary fallBack={ErrorFallback}>
      <Cta primary isSubmitting={isSubmitting} submittingLabel={submittingLabel} {...rest}>
        {children}
      </Cta>
    </ErrorBoundary>
  )
}

const ErrorFallback = () => <div className="text-error">Ocurrio un error</div>

export default PrimaryCta
